import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Show a stored value as a label: "need_help_register" → "Need help register". Anything with capitals or punctuation is already written for people and is left alone. */
export function humanize(s: string): string {
  if (!/^[a-z0-9]+([ _-][a-z0-9]+)*$/.test(s)) return s;
  const t = s.replace(/[_-]+/g, " ");
  return t.charAt(0).toUpperCase() + t.slice(1);
}
